import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Select from 'react-select';
import { endOfYear } from "date-fns";

import { addUpdateSettings, getDeductionSettings } from "../../../store/actions";
import { weekDays } from '../../../utils/constants';

import ReportDateRange from "../../../components/reportDateRange";
import OurModal from "../../../components/ourModal";
import "./style.scss";

const deductionSumTypes = [{ val: "flat", label: "Flat - $$ Amount" }, { val: "percent", label: "Percent - % Of Earning" }];
const employeeSelectionTypes = ["cost-center", "extra-field", "hr-field"];
const runOptions = [{ val: "calculated", label: "Calculated - based on Payroll Finalized Date" }, { val: "fixed", label: "Fixed - on Specific Day of Week" }]

export const ScheduleModal = (props) => {
    const { isEdit, company, companyName, settings } = props;
    const {
        _id,
        scheduleName,
        startDate,
        endDate,
        ein,
        deductionCode,
        earningList,
        payPeriod,
        runDayType,
        runOnDay,
        deductionSumType,
        deductionAmount,
        deductionCap,
        monthlyCap,
        monthlyMin,
        employeeGroupType,
        costCenterParent,
        costCenters,
        extraFieldIndex,
        extraFieldValue,
        hrFieldValue,
        daysAfterStart
    } = settings;
    const [name, setName] = useState(scheduleName || "");
    const [companyEinsList, setCompanyEinsList] = useState([]);
    const [multiEin, setMultiEin] = useState(false);
    const [periodProfilesList, setPayPeriodProfiles] = useState([]);
    const [deductionCodes, setDeductionCodes] = useState([]);
    const [parentCCList, setParents] = useState([]);
    const [costCenterList, setCostCenterList] = useState([]);
    const [earningListValue, setSelectedEarning] = useState("");
    const [selectedEin, setSelectedEin] = useState("");
    const [selectedDeduction, setDeduction] = useState("");
    const [selectedProfile, setSelectedProfile] = useState("");
    const [selectedStartDate, setStartDate] = useState(startDate || new Date());
    const [selectedEndDate, setEndDate] = useState("");
    const [selectedWeekDay, setWeekDay] = useState("");
    const [whenToRun, setWhenToRun] = useState("");
    const [sumType, setSumType] = useState("");
    const [amount, setAmount] = useState(deductionAmount || null);
    const [amountCap, setAmountCap] = useState(deductionCap || null);
    const [monthCap, setMonthCap] = useState(monthlyCap || null);
    const [minimumDeduction, setMinimum] = useState(monthlyMin || null);
    const [gracePeriod, setGracePeriod] = useState(daysAfterStart || null);
    const [employeesFrom, setEmployeesFrom] = useState(employeeGroupType || "");
    const [selectedCCParent, setParent] = useState("");
    const [selectedCostCenters, setSelectedCostCenters] = useState([]);
    const [customField, setCustomField] = useState(extraFieldIndex || null);
    const [customFieldVal, setCustomVal] = useState(extraFieldValue || "");
    const [hrFieldVal, setHrVal] = useState(hrFieldValue || "");
    const [noEndDate, toggleNoEndDate] = useState(true);
    const [dateErrMsg, setDateErrMsg] = useState(false);

    useEffect(() => {
        groupCostCenters();
        if (props?.CompanyEinsReducer.length > 1) {
            setMultiEin(true);
            setCompanyEinsList(props?.CompanyEinsReducer);
            /* if (ein) {
                let selectedEin = props?.CompanyEinsReducer.find(cEin => cEin._id === ein)?.companyEIN || "";
                setSelectedEin(selectedEin);
            }; */
        }
        else onSelectEIN();
        setAllStates();
    }, [settings]);

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            fontSize: '14px',
            height: '38px',
            color: '#444444',
            border: '1px solid #ccc',
            borderColor: state.isFocused ? '#47E5EB' : '#ccc',
            boxShadow: state.isFocused ? '0 0 0 1px #47E5EB' : null,
            '&:hover': {
                borderColor: state.isFocused ? '#47E5EB' : '#ccc'
            },
            cursor: 'pointer',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#47E5EB' : 'white',
            color: state.isSelected ? 'white' : 'black',
            '&:hover': {
                backgroundColor: state.isSelected ? '#47E5EB' : '#46e6ec33'
            },
            padding: '3px 18px',
            fontSize: '16px',
            cursor: 'pointer',
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
            color: '#444444',
        })
    }

    function setAllStates() {
        if (isEdit) {
            setStartDate(new Date(startDate));
            if (endDate) {
                setEndDate(new Date(endDate));
                toggleNoEndDate(false);
            };
            if (ein) {
                let selectedEin = props?.CompanyEinsReducer?.find(cEin => cEin._id === ein)?.companyEIN || "";
                onSelectEIN(selectedEin);
            }
            if (runOnDay) setWeekDay(runOnDay);
            setName(scheduleName);
            setWhenToRun(runDayType);
            setSumType(deductionSumType);
            setAmount(deductionAmount);
            setSelectedEarning(earningList);
            setAmountCap(deductionCap);
            setMonthCap(monthlyCap);
            setMinimum(monthlyMin);
            setEmployeesFrom(employeeGroupType);
            if (extraFieldIndex) setCustomField(extraFieldIndex);
            if (extraFieldIndex) setCustomVal(extraFieldValue);
            if (hrFieldValue) setHrVal(hrFieldValue);
        }
    };

    function onToggleEndDate(val) {
        let endYear = "";
        if (!val) {
            endYear = endOfYear(new Date());
        };
        setEndDate(endYear);
        toggleNoEndDate(val);
    };

    function groupCostCenters() {
        let groupedCC = props?.COST_CENTERS?.reduce((list, elem) => {
            if (!elem.parentId) {
                elem.children = props?.COST_CENTERS?.filter(cc => cc.parentId === elem.id).map(cc => ({ ...cc, label: cc.name, value: cc.id }));
                elem.value = elem.id;
                elem.label = elem.name;
                list.push(elem);
            };
            return list;
        }, []);
        setParents(groupedCC);

        if (costCenterParent) {
            onSelectParentCC(groupedCC.find(pc => pc.id === costCenterParent), true)
        };
    };


    async function getDeductionCodes(einName) {
        let ddcCodes = props.DeductionCodesReducer?.filter(d => {
            if (einName) {
                return d.linkedEINs && d.linkedEINs.includes(einName);
            }
            else return true;
        }).map(dc => ({ ...dc, value: dc._id, label: dc.deductionName }));
        setDeductionCodes(ddcCodes || []);
        if (deductionCode) setDeduction(ddcCodes.find(d => d._id === deductionCode));
    };

    function getPayPeriodProfiles(einName) {
        let profiles = props.PayPeriodProfilesReducer.filter(pp => {
            return einName ? pp.EIN && pp.EIN === einName : true
        }).map(pp => ({ ...pp, value: pp._id, label: pp.profileName }));
        setPayPeriodProfiles(profiles || []);
        if (payPeriod) {
            let selectedPeriod = profiles?.find(pp => pp._id === payPeriod);
            setSelectedProfile(selectedPeriod);
        }
    };

    function onSelectEIN(einName) {
        setSelectedEin(einName);
        getDeductionCodes(einName);
        getPayPeriodProfiles(einName);
    };

    function onSelectParentCC(val, firstLoad) {
        setParent(val);
        setCostCenterList(val.children);
        if (firstLoad) {
            let selectedChildren = val.children.filter(c => costCenters.includes(c.id));
            setSelectedCostCenters(selectedChildren);
        } else {
            setSelectedCostCenters([]);
        };

    };

    function handleStart(start) {
        setStartDate(new Date(start));
    };

    function handleEnd(end) {
        if (new Date(end) < new Date(selectedStartDate)) {
            setDateErrMsg(true);
        } else {
            setDateErrMsg(false);
            setEndDate(new Date(end));
        }
    };

    function onClose() {
        return props.onClose();
    };

    async function addUpdateDeductionSettings() {
        if (noEndDate) setEndDate("");
        if (employeesFrom !== "cost-center") {
            setParent("");
            setSelectedCostCenters([]);
        }

        let payload = {
            company,
            scheduleName: name || `${companyName}${selectedEin ? "/" + selectedEin + " " : ""}${selectedDeduction.deductionName} ${selectedStartDate.toLocaleDateString()}-${selectedEndDate ? selectedEndDate.toLocaleDateString() : "No End Date"}`,
            startDate: selectedStartDate,
            endDate: selectedEndDate,
            ein: companyEinsList.find(ein => ein.companyEIN === selectedEin)?._id || "",
            deductionCode: selectedDeduction.value,
            earningList: earningListValue,
            payPeriod: selectedProfile._id,
            runDayType: whenToRun,
            runOnDay: selectedWeekDay,
            deductionSumType: sumType,
            deductionAmount: amount,
            deductionCap: amountCap,
            monthlyCap: monthCap,
            monthlyMin: minimumDeduction,
            employeeGroupType: employeesFrom,
            costCenterParent: selectedCCParent.id,
            costCenters: selectedCostCenters.map(c => c.id),
            extraFieldIndex: customField,
            extraFieldValue: customFieldVal,
            hrFieldValue: hrFieldVal,
            daysAfterStart: gracePeriod
        };
        if (_id) { payload._id = _id; }
        await props.addUpdateSettings(payload);
        await props.getDeductionSettings({ company });
        onClose();
    };

    function generateScheduleName() {
        const scheduleName = `${companyName}${selectedEin ? "/" + selectedEin + " " : " "}${selectedDeduction?.deductionName || "Deduction Report"} ${selectedStartDate.toLocaleDateString()} - ${selectedEndDate ? selectedEndDate.toLocaleDateString() : "No End Date"}`

        let i = 0;
        const interval = setInterval(() => {
            setName(scheduleName.slice(0, i));
            i++;
            if (i > scheduleName.length) {
                clearInterval(interval);
            }
        }, 100);
    }

    return (
        <>
            {props.show && (
                <OurModal
                    onClose={onClose}
                    title={`${isEdit ? 'Edit' : 'Add'} Schedule`}
                    saveBtnText={isEdit ? 'Update' : 'Save'}
                    onSave={addUpdateDeductionSettings}
                >
                    {/* Schedule Name */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Schedule Name</label>
                        </div>
                        <div className="single-input-field">
                            <div className="schedule-name">
                                <input type="text"
                                    className="schedule-name-input"
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                    placeholder={`${companyName} ${selectedEin ? "/" + selectedEin + " " : ""}${selectedDeduction?.deductionName || ""} ${selectedStartDate ? new Date(selectedStartDate).toLocaleDateString() : new Date().toLocaleDateString()} - ${selectedEndDate ? selectedEndDate.toLocaleDateString() : "No End Date"}`}
                                />
                                <img
                                    className="schedule-name-icon"
                                    width="24"
                                    height="24"
                                    src="https://img.icons8.com/forma-thin/24/sparkling.png"
                                    alt="sparkling"
                                    title="Tip: Click the icon after filling the form to generate a accurate schedule name"
                                    onClick={generateScheduleName}
                                />
                            </div>
                        </div>
                    </div>


                    {/* Start Date */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select Start Date</label>
                        </div>
                        <div className="single-input-field">
                            <div className="start-date-section">
                                <ReportDateRange
                                    mode="single"
                                    monthsShown={1}
                                    handleDateRange={handleStart}
                                    startDate={selectedStartDate}
                                    style={{
                                        container: {
                                            width: '100%',
                                        },
                                        input: {
                                            width: '100%',
                                        }
                                    }}
                                />
                                <label>
                                    <input
                                        type="checkbox"
                                        key="endDate"
                                        checked={noEndDate}
                                        onChange={e => onToggleEndDate(e.target.checked)}
                                    />
                                    No End Date
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* End Date */}
                    {!noEndDate && <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select End Date</label>
                        </div>
                        <div className="single-input-field">
                            <ReportDateRange
                                mode="single"
                                monthsShown={1}
                                handleDateRange={handleEnd}
                                startDate={selectedEndDate}
                                style={{
                                    container: {
                                        width: '100%',
                                    },
                                    input: {
                                        width: '100%',
                                    }
                                }}
                            />
                            {dateErrMsg && <div className="date-error-msg">End date before start date?  come on... select a different date</div>}
                        </div>
                    </div>}

                    {/* EIN */}
                    {multiEin &&
                        <div className="modal-row">
                            <div className="single-select-label">
                                <label>Select EIN</label>
                            </div>
                            <div className="single-input-field">
                                <select value={selectedEin} onChange={e => onSelectEIN(e.target.value)}>
                                    <option value="" key="report1">Select EIN</option>
                                    {companyEinsList.map(ein => (
                                        <option key={ein.systemId} value={ein.companyEIN}>{ein.companyEIN}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    }

                    {/* Deduction Code */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select Deduction Codes</label>
                        </div>
                        <div className="single-input-field">
                            <Select
                                isClearable={true}
                                value={selectedDeduction}
                                onChange={setDeduction}
                                options={deductionCodes}
                                placeholder="Select Deduction Code"
                                styles={selectStyles}
                            />
                        </div>
                    </div>

                    {/* Profile */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select Payroll Profile</label>
                        </div>
                        <div className="single-input-field">
                            <Select
                                value={selectedProfile}
                                onChange={setSelectedProfile}
                                options={periodProfilesList}
                                isClearable={true}
                                placeholder="Select PayPeriod Profile"
                                styles={selectStyles}
                            />
                        </div>
                    </div>

                    {/* Run  Day Type */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Schedule Type</label>
                        </div>
                        <div className="single-input-field">
                            <select value={whenToRun} onChange={e => setWhenToRun(e.target.value)}>
                                <option value="" key="report1">Set Schedule Type</option>
                                {runOptions.map((r, idx) => (
                                    <option
                                        key={idx}
                                        value={r.val}
                                    >
                                        {r.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Run On Day */}
                    {whenToRun === 'fixed' &&
                        <div className="modal-row">
                            <div className="single-select-label">
                                <label>Select Day of the Week</label>
                            </div>
                            <div className="single-input-field">
                                <select value={selectedWeekDay} onChange={e => setWeekDay(e.target.value)}>
                                    <option value="" key="report1">Select Day</option>
                                    {weekDays.map((wd, idx) => (
                                        <option
                                            key={idx}
                                            value={idx}
                                        >
                                            {wd}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    }

                    {/* Deduction Type */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select Type of Deduction</label>
                        </div>
                        <div className="single-input-field">
                            <select value={sumType} onChange={e => setSumType(e.target.value)}>
                                <option value="" key="report1">Select Deduction Type</option>
                                {deductionSumTypes.map((tp) => (
                                    <option
                                        key={tp.label}
                                        value={tp.val}
                                    >
                                        {tp.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Deduction Amount */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Deduction Amount {sumType === 'percent' ? "- %" : ""}</label>
                        </div>
                        <div className="single-input-field">
                            <input type="number" className="single-input" onChange={e => setAmount(e.target.value)} value={amount}></input>
                        </div>
                    </div>

                    {/* Earning List */}
                    {sumType === 'percent' &&
                        <div className="modal-row">
                            <div className="single-select-label">
                                <label>From Earning List</label>
                            </div>
                            <div className="single-input-field">
                                <input
                                    type="text"
                                    className="single-input"
                                    value={earningListValue}
                                    onChange={e => setSelectedEarning(e.target.value)}
                                    placeholder="Type/Paste Here">
                                </input>
                            </div>
                        </div>
                    }

                    {/* Percentage Settings */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Cap Per Payroll {sumType === 'percent' ? "- $" : "- %"} <small>(optional)</small></label>
                        </div>
                        <div className="single-input-field">
                            <input type="number" className="single-input" value={amountCap} onChange={e => setAmountCap(e.target.value)}></input>
                        </div>
                    </div>

                    {/* Earning List */}
                    {sumType === 'flat' &&
                        <div className="modal-row">
                            <div className="single-select-label">
                                <label>From Earning List</label>
                            </div>
                            <div className="single-input-field">
                                <input
                                    type="text"
                                    className="single-input"
                                    value={earningListValue}
                                    onChange={e => setSelectedEarning(e.target.value)}
                                    placeholder="Type/Paste Here">
                                </input>
                            </div>
                        </div>
                    }

                    {/* Monthly Cap */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Monthly Cap <small>(optional)</small></label>
                        </div>
                        <div className="single-input-field">
                            <input type="number" className="single-input" onChange={e => setMonthCap(e.target.value)} value={monthCap}></input>
                        </div>
                    </div>

                    {/* Monthly Min */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Monthly Minimum <small>(optional)</small></label>
                        </div>
                        <div className="single-input-field">
                            <input type="number" className="single-input" onChange={e => setMinimum(e.target.value)} value={minimumDeduction}></input>
                        </div>
                    </div>


                    {/* Grace Period */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Set Grace Period <small>(in Days)</small></label>
                        </div>
                        <div className="single-input-field">
                            <input
                                type="number"
                                className="single-input"
                                onChange={e => setGracePeriod(e.target.value)}
                                value={gracePeriod}
                                min="0"
                                defaultValue={"0"}
                            ></input>
                        </div>
                    </div>


                    {/* Employee List Type */}
                    <div className="modal-row">
                        <div className="single-select-label">
                            <label>Select Employees From</label>
                        </div>
                        <div className="single-input-field">
                            <select value={employeesFrom} onChange={e => setEmployeesFrom(e.target.value)}>
                                <option value="" key="report1">Select Employees Source</option>
                                {employeeSelectionTypes.map(emp => (
                                    <option
                                        key={emp}
                                        value={emp}
                                    >
                                        {emp}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Cost Center Parent */}
                    {employeesFrom === 'cost-center' && <>
                        <div className="modal-row">
                            <div className="single-select-label">
                                <label>Select Cost Center</label>
                            </div>
                            <div className="single-input-field">
                                <Select
                                    menuPlacement="top"
                                    value={selectedCCParent}
                                    onChange={async (selected) => onSelectParentCC(selected)}
                                    options={parentCCList}
                                    styles={selectStyles}
                                >
                                </Select>
                            </div>
                        </div>

                        {/* Child Cost Centers */}
                        {selectedCCParent && <div className="modal-row">
                            <div className="single-select-label">
                                <label>Select Cost Centers</label>
                            </div>
                            <div className="single-input-field">
                                <Select
                                    menuPlacement="top"
                                    value={selectedCostCenters}
                                    options={costCenterList}
                                    onChange={setSelectedCostCenters}
                                    isMulti={true}
                                    isClearable={true}
                                    isSearchable={true}
                                    styles={selectStyles}
                                />
                            </div>
                        </div>
                        }
                    </>
                    }

                    {/* Extra Field */}
                    {employeesFrom === 'extra-field' && <div className="modal-row">
                        <div className="single-select-label">
                            <label>Extra Field</label>
                        </div>
                        <div className="single-input-field">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-4">
                                    <input className="single-input" type="number" placeholder="Index" min={1} max={10} value={customField} onChange={e => setCustomField(e.target.value)}></input>
                                </div>
                                <div className="col-8">
                                    <input className="single-input" type="text" placeholder="Value" value={customFieldVal} onChange={e => setCustomVal(e.target.value)}></input>
                                </div>
                            </div>
                        </div>
                    </div>}

                    {/* HR Field */}
                    {employeesFrom === 'hr-field' && <div className="modal-row">
                        <div className="single-select-label">
                            <label>Enter HR Field</label>
                        </div>
                        <div className="single-input-field">
                            <input type="text" className="single-input" value={hrFieldVal} onChange={e => setHrVal(e.target.value)}></input>
                        </div>
                    </div>}
                </OurModal >
            )
            }
        </>
    );
};


const mapStateToProps = ({ CompanyEinsReducer, CostCenterReducer, DeductionCodesReducer, DeductionSchedulesReducer, PayPeriodProfilesReducer, }) => {
    const { COST_CENTERS, PARENT_COST_CENTERS } = CostCenterReducer;
    return { CompanyEinsReducer, COST_CENTERS, PARENT_COST_CENTERS, DeductionSchedulesReducer, DeductionCodesReducer, PayPeriodProfilesReducer, };
};
export default connect(mapStateToProps, {
    addUpdateSettings,
    getDeductionSettings
})(ScheduleModal);